/**
 * 包含一些零碎的业务的路由
 */
import {
    loadPageFail
} from '../lib/units';

export default [{
        name: 'paymentUnlock',
        path: '/paymentUnlock',
        meta: {
            title: '支付解锁页',
            fullTitle: function() {
                return '支付解锁页';
            }
        },
        component: resolve => require(['../pages/notLogin/payment-unlock.vue'], resolve, (err) => {
            loadPageFail({
                pagename: '支付解锁页',
                err
            });
        })
    },
    {
        name: 'paymentcardSuccess',
        path: '/paymentcardSuccess',
        meta: {
            title: '成功购买页',
            fullTitle: function() {
                return '成功购买页';
            }
        },
        component: resolve => require(['../pages/notLogin/paymentcard-success.vue'], resolve, (err) => {
            loadPageFail({
                pagename: '成功购买页',
                err
            });
        })
    },
    {
        name: 'paymentTis',
        path: '/paymentTis',
        meta: {
            title: '客服页',
            fullTitle: function() {
                return '客服页';
            }
        },
        component: resolve => require(['../pages/notLogin/payment-tis.vue'], resolve, (err) => {
            loadPageFail({
                pagename: '客服页',
                err
            });
        })
    },
    {
        name: 'paymentCikeSuccess',
        path: '/paymentCikeSuccess',
        meta: {
            title: '成功购买咨询页',
            fullTitle: function() {
                return '成功购买咨询页';
            }
        },
        component: resolve => require(['../pages/notLogin/payment-cike-success.vue'], resolve, (err) => {
            loadPageFail({
                pagename: '成功购买咨询页',
                err
            });
        })
    },
    {
        name: 'quickUnlock',
        path: '/quickUnlock',
        meta: {
            title: '快速解锁页',
            fullTitle: function() {
                return '快速解锁页';
            }
        },
        component: resolve => require(['../pages/notLogin/quick-unlock.vue'], resolve, (err) => {
            loadPageFail({
                pagename: '快速解锁页',
                err
            });
        })
    },
    {
        name: 'attentionQrcode',
        path: '/attention-qrcode',
        meta: {
            title: '关注公众号',
            fullTitle: function() {
                return '关注公众号';
            }
        },
        component: resolve => require(['../pages/notLogin/attention-qrcode.vue'], resolve, (err) => {
            loadPageFail({
                pagename: '关注公众号',
                err
            });
        })
    },
    {
        name: 'loadingProgress',
        path: '/loading-progress',
        meta: {
            title: '加载进度条',
            fullTitle: function() {
                return '加载进度条';
            }
        },
        component: resolve => require(['../pages/notLogin/loading-progress.vue'], resolve, (err) => {
            loadPageFail({
                pagename: '加载进度条',
                err
            });
        })
    },
    {
        name: 'saveReport',
        path: '/save-report',
        meta: {
            title: '保存个人测评结果',
            fullTitle: () => '保存个人测评结果'
        },
        component: resolve => require(['../pages/notLogin/save-report.vue'], resolve, (err) => {
            loadPageFail({
                pagename: '保存个人测评结果',
                err
            });
        })
    },
    // 放在小程序 webview 中的二维码落地页
    {
        name: 'wechatAppQrcode',
        path: '/wechat-app-qrcode',
        meta: {
            title: '永久保存报告',
            fullTitle: function() {
                return '永久保存报告';
            }
        },
        component: resolve => require(['../pages/notLogin/wechat-app-qrcode.vue'], resolve, (err) => {
            loadPageFail({
                pagename: '永久保存报告',
                err
            });
        })
    },
]


// WEBPACK FOOTER //
// ./src/router/launch.js